<script>
export default {
  name: "MegaSubMenu",
  props: {
    menuIdx: {
      type: Number,
      default: 0,
    },
    nav: {
      type: Object,
      required: true
    }
  },
  computed: {
    asAccordion() {
      return this.nav.column.length > 1
    },
  }
}

</script>

<template>
  <div tabindex="-1" :id="`offcanvasSubmenu${menuIdx}`"
       class="submenu desktop-menu-content offcanvas offcanvas-end w-100"
       style="max-width: 1160px;">
    <div class="offcanvas-header d-flex align-items-center bg-ck-blue text-white px-3">
      <h5 data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasNavbar"
          aria-controls="offcanvasNavbar"
          class="submenu-title my-0">
        <i aria-hidden="true" class="fa-solid fa-chevron-left"></i> BACK
      </h5>
      <i aria-label="Close"
         data-bs-dismiss="offcanvas"
         aria-hidden="true"
         class="close-submenu fa-solid fa-xmark fs-2"></i>
    </div>
    <div class="desktop-menu-header bg-ck-blue text-white lh-4 fw-bold text-center d-none d-md-block font-ck-heading fs-ck-2rem text-uppercase">
      {{ nav.display_title }}
    </div>
    <div :id="`submenu${menuIdx}`" class="mega-menu accordion accordion-flush">
      <div v-for="(column, colIdx) in nav.column" :key="column._metadata.uid" class="submenu-column">
        <div
            v-for="(category, catIdx) in column.categories"
            :key="category._metadata.uid"
            :class="{'d-md-none': !['both', 'desktop'].includes(category.select_category_for), 'd-none d-md-block': !['both', 'mobile'].includes(category.select_category_for) }"
            class="accordion-item">
            <div v-if="category.subcategory_nav_list.length === 0" class="submenu-callout">
              <h2 class="submenu-header-link">
                <a :href="category.category_direct_link.href"
                   :title="category.category_direct_link.title"
                   class="submenu-callout-link">
                  {{ category.category_title }}&nbsp;<i aria-hidden="true" class="fa-solid fa-arrow-right"></i>
                </a>
              </h2>
            </div>
            <template v-else>
              <h2 v-if="asAccordion" :id="`submenu${menuIdx}-item${colIdx}${catIdx}-header`" class="accordion-header d-md-none">
                <button type="button" data-bs-toggle="collapse"
                        :data-bs-target="`#submenu${menuIdx}-item${colIdx}${catIdx}-content`"
                        aria-expanded="false" :aria-controls="`submenu${menuIdx}-item${colIdx}${catIdx}-content`"
                        class="accordion-button collapsed text-uppercase">
                  {{ category.category_title }}
                </button>
              </h2>
              <h2 v-if="category.select_link_type === 'None'" class="desktop-submenu-header d-none d-md-block text-uppercase">
                {{ category.category_title }}
              </h2>
              <h2 v-else-if="category.select_link_type === 'Internal'" class="submenu-header-link d-none d-md-block">
                <a :href="category.category_direct_link.href"
                   :title="category.category_direct_link.title"
                   class="submenu-callout-link">{{ category.category_title }}&nbsp;<i aria-hidden="true"
                                                                                      class="fa-solid fa-arrow-right"></i>
                </a>
              </h2>
              <h2 v-else-if="category.select_link_type === 'External'" class="submenu-header-link d-none d-md-block">
                <a :href="category.category_direct_link.href"
                   :title="category.category_direct_link.title"
                   target="_blank"
                   class="submenu-callout-link">{{ category.category_title }}&nbsp;<i aria-hidden="true"
                                                                                      class="fa-solid fa-arrow-up-right-from-square"></i>
                </a>
              </h2>
              <div class="d-none d-md-block">
                <a v-for="(subCategory, subCatIdx) in category.subcategory_nav_list"
                   :key="subCategory._metadata.uid"
                   :href="subCategory.link.href"
                   :title="subCategory.link.title"
                   class="submenu-item-link">
                  <span v-html="subCategory.sub_category_title"></span>
                </a>
              </div>
              <div :id="`submenu${menuIdx}-item${colIdx}${catIdx}-content`"
               :aria-labelledby="`submenu${menuIdx}-item${catIdx}-header`" :data-bs-parent="`#submenu${menuIdx}`"
               :class="{'accordion-collapse collapse': asAccordion, 'px-3': !asAccordion}">
                <div :class="{'accordion-body': asAccordion}">
                  <a v-for="subCategory in category.subcategory_nav_list"
                     :key="subCategory._metadata.uid"
                     :href="subCategory.link.href"
                     :title="subCategory.link.title"
                     class="submenu-item-link d-md-none">
                    <span class="d-none d-md-inline-block" v-html="subCategory.sub_category_title "></span>
                    <span class="d-md-none" v-html="subCategory.sub_category_mobile_title"></span>
                  </a>
                </div>
              </div>
            </template>
        </div>
      </div>
      <div v-if="nav.promo_column != null" class="submenu-column promo-column">
        <div
            v-for="cta in nav.promo_column.cta_button"
            class="submenu-link d-md-none"><a :href="cta.href" :title="cta.title">{{ cta.title }}</a>
        </div>
        <template
            v-if="nav.promo_column.promo_mobile!= null && nav.promo_column.promo_mobile.length > 0"
        >

          <a
              :href="promo.promo_link.href"
              :title="promo.promo_link.title"
              v-for="promo in nav.promo_column.promo_mobile" :key = "promo.uid" class="submenu-promospot d-md-none p-3 d-flex"
          >
            <img height="144" width="144"
                 :src="promo.promo_image.url"
                 :alt="promo.promo_image.title"
                 loading="lazy" class="submenu-promospot-image">
            <div class="submenu-promospot-right flex-grow-1 bg-light text-center">
              <div class="submenu-promospot-title text-primary">
                {{ promo.promo_title }}
              </div>
              <span
                 class="submenu-callout-button badge rounded-pill text-white px-4 py-1 border border-white border-1 d-inline-block mb-2">
                {{ promo.promo_link.title }}
              </span>
            </div>
          </a>

        </template>
      </div>
      <div v-if="nav.promo_column != null"
           class="desktop-submenu-promospot text-black d-none d-lg-flex flex-column mb-3">
        <div v-for="promo in nav.promo_column.promo" class="promospot-block promoSpot" :key="promo.uid">
          <a :href="promo.promo_link.href" data-cktag="mega-menu mtg block1 item1" :title="promo.promo_link.title">
            <img
                :src="promo.promo_image.url"
                :alt="promo.promo_image.title" loading="lazy" class="img-fluid">
          </a>
        </div>
        <div class="promospot-block promoSpot my-3">
          <div v-for="cta in nav.promo_column.cta_button" class="mega-menu-promo-button d-none d-md-block rounded-pill">
            <a :href="cta.href" :title="cta.title" data-cktag="mega-menu mtg block2 button1">{{ cta.title }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
